import { render, staticRenderFns } from "./Histoire.vue?vue&type=template&id=0f5f41a4&"
import script from "./Histoire.vue?vue&type=script&lang=js&"
export * from "./Histoire.vue?vue&type=script&lang=js&"
import style0 from "./Histoire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports